import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthCallbackComponent } from './components/auth-callback/auth-callback.component';
import { AuthLogoutCallbackComponent } from './components/auth-logout-callback/auth-logout-callback.component';
import { AuthLogoutComponent } from './components/auth-logout/auth-logout.component';
import { AuthSilentComponent } from './components/auth-silent/auth-silent.component';

const routes: Routes = [
  { path: 'auth-callback', component: AuthCallbackComponent },
  { path: 'auth-silent', component: AuthSilentComponent },
  { path: 'logout-callback', component: AuthLogoutCallbackComponent },
  { path: 'logout', component: AuthLogoutComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
